import * as Icons from '@fortawesome/free-solid-svg-icons';
import { Button } from 'rbx';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { css } from 'emotion';

const iconCSS = css`
  margin-right: 0.5em;
`;

/**
 * "Cancel at period end" and "Cancel immediately", each needing a second
 * click to confirm — the same as the main subscription panel.
 *
 * @param {Function} onCancel - Called with `immediately` (true/false).
 * @param {boolean} endingAlready - Already set to end at period end, so only
 *   the immediate cancel is offered.
 */
function CancelButtons({ onCancel, endingAlready }) {
  const [confirm, setConfirm] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const click = immediately => async () => {
    const which = immediately ? 'now' : 'end';
    if (confirm !== which) return setConfirm(which);
    setBusy(true);
    setError(null);
    try {
      await onCancel(immediately);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
      setConfirm(null);
    }
  };

  return (
    <>
      <Button.Group>
        {!endingAlready && (
          <Button
            color="danger"
            disabled={busy}
            title="Cancel at end of billing period"
            onClick={click(false)}
          >
            <FontAwesomeIcon icon={Icons.faTimesCircle} className={iconCSS} />
            {confirm === 'end'
              ? 'Are you sure? Click to confirm'
              : 'Cancel subscription'}
          </Button>
        )}
        <Button
          color="danger"
          outlined={!endingAlready}
          disabled={busy}
          title="Cancel immediately"
          onClick={click(true)}
        >
          <FontAwesomeIcon icon={Icons.faTimesCircle} className={iconCSS} />
          {confirm === 'now'
            ? 'Are you sure? Click to confirm'
            : 'Cancel immediately'}
        </Button>
      </Button.Group>
      {error && <p className="has-text-danger">{error}</p>}
    </>
  );
}

export default CancelButtons;
